import { render, staticRenderFns } from "./modalBox.vue?vue&type=template&id=3a03e9e6&"
import script from "./modalBox.vue?vue&type=script&lang=js&"
export * from "./modalBox.vue?vue&type=script&lang=js&"
import style0 from "./modalBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports